import React, { useState, useRef, useEffect } from 'react';
import './BadgeSlider.css';
import './styles/ipad.css';
import './styles/mobile.css';
import { BadgeSliderProps } from './BadgeSlider.props';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperClass } from 'swiper';
import 'swiper/css';
import AchievementsBadgePopover from '../AchievementsBadgePopover/AchievementsBadgePopover';
import {handleErrorImg, parseImgURLBadge, sortBadges} from '../../utils/util';

const BadgeSlider: React.FC<BadgeSliderProps> = ({ badgeList = [] }) => {
  const swiperRef = useRef<SwiperClass | null>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [badgeData, setBadgeData] = useState<any>({});
  const [badgeListData, setBadgeListData] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleCloseHoverBadge = () => {
    setAnchorEl(null);
  };
  const handleClearBadgeData = () => {
    setBadgeData({});
  };

  const handleHoverBadge = (event: React.MouseEvent<HTMLElement>, val: any) => {
    setBadgeData(val);
    setAnchorEl(event.currentTarget);
  };
  const handleSwiperUpdate = (swiper: SwiperClass) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  useEffect(() => {
    const sortedBadgeList = sortBadges(badgeList);
    setBadgeListData([]);
    setBadgeListData(sortedBadgeList);
    if (swiperRef.current) {
      swiperRef.current.update();
      setIsBeginning(swiperRef.current.isBeginning);
      setIsEnd(swiperRef.current.isEnd);
    }
  }, [badgeList]);

  return (
    <>
      <div className="swiper-badge-wrapper">
        <button
          data-testid="badge-nav-btn-previous"
          className="badge-nav-button previous"
          onClick={() => swiperRef.current?.slidePrev()}
          disabled={isBeginning || !badgeList?.length}
          style={{marginRight:"4px"}}>
          <span className="arrow-icon">{'\u25C4'}</span>
        </button>

        <Swiper
          observer
          observeParents
          observeSlideChildren
          spaceBetween={20}
          slidesPerView="auto"
          onSwiper={(swiper: SwiperClass) => {
            swiperRef.current = swiper;
            handleSwiperUpdate(swiper);
          }}
          onSlideChange={(swiper: SwiperClass) => handleSwiperUpdate(swiper)}
          onResize={(swiper: SwiperClass) => handleSwiperUpdate(swiper)} // <– add this!
          onReachEnd={(swiper: SwiperClass) => handleSwiperUpdate(swiper)} // <– add this!
          onReachBeginning={(swiper: SwiperClass) => handleSwiperUpdate(swiper)}
          className="swiper-badge-container">
          {badgeListData &&
            badgeListData.length > 0 &&
            badgeListData.map((item: any, index: number) => (
              <SwiperSlide
                className="badge-slider-item"
                key={item.badgeId}
                onMouseEnter={(e) => {
                  handleHoverBadge(e, item);
                }}
                onMouseLeave={() => {
                  handleCloseHoverBadge();
                }}>
                <img
                  style={{ height: 60, width: 60 }}
                  key={item.badgeId}
                  src={parseImgURLBadge(item.category, item.badgeId)}
                  alt={`badge-${index}`}
                  onError={handleErrorImg}
                  data-testid="badge-img"
                />
              </SwiperSlide>
            ))}
        </Swiper>

        <button
          data-testid="badge-nav-btn-next"
          className="badge-nav-button next"
          onClick={() => swiperRef.current?.slideNext()}
          disabled={isEnd || !badgeList?.length}>
          <span className="arrow-icon">{'\u25BA'}</span>
        </button>
      </div>
      <AchievementsBadgePopover
        open={Boolean(anchorEl)}
        data={badgeData}
        anchorEl={anchorEl}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 280, left: 680 }}
        onExited={handleClearBadgeData}
      />
    </>
  );
};

export default BadgeSlider;
